
import { JobKanbanWrapper } from "./kanban/JobKanbanWrapper";

interface JobKanbanProps {
  jobId: string | undefined;
  skills?: string[];
  refreshKey?: number;
}

export const JobKanban = ({ jobId, skills = [], refreshKey }: JobKanbanProps) => {
  return <JobKanbanWrapper jobId={jobId} jobSkills={skills} refreshKey={refreshKey} />;
};
